import { Box, Grid } from "@mui/material"
import BreadCrumbs from "components/Breadcrumbs/Breadcrumbs"
import DrawerHeader from "components/DrawerHeader"
import { CommonTexts } from "locale/es"
import DisplayProfessionals from "./DisplayProfessionals"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserDoctor } from "@fortawesome/free-solid-svg-icons";
import { AppColors } from "resources/AppColors"

const ProfessionalsManagement = () =>
  <Box component="main" sx={{ flex: 1, p: 3, mb: 20 }}>
    <DrawerHeader />
    <BreadCrumbs
      name={CommonTexts.PROFESSIONALS}
      icon={<FontAwesomeIcon icon={faUserDoctor} size='xs' fixedWidth style={{ color: AppColors.PRIMARY, marginRight: "4px" }} />}
    />
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
    >
      <DisplayProfessionals />
    </Grid>
  </Box>

export default ProfessionalsManagement